export const en = {
  common: {
    contactUs: "Contact us",
    loading: "Loading",
    errors: {
      unknown: "Something went wrong",
      loadingImage: "There was an error while loading the image: ",
      checkOptions:
        "Please add text to the plate or upload photos before continuing.",
    },
  },
  toasts: {
    cartSaved: "Cart saved",
  },
  tooltips: {
    infoButton: "Press for more info",
  },
  pages: {
    home: {
      title: "Home",
      start: "Get started",
    },
    clubChoose: {
      title: "CHOOSE YOUR CLUB",
      subtitleLineOne:
        "Select your club or skip to continue with a default shirt.",
      subtitleLineTwo:
        "You can change the club in the configurator at all time",
      shipping: "Shipping to Netherlands - ",
      shippingButton: "change",
      skipButton: "Skip",
      continueButton: "Continue with ",
      continueButtonMobile: "Continue",
      clubChooseTitle: "CLUBS IN YOUR COUNTRY",
      changeCountry: "Change country",
      showMoreCountries: {
        FR: "Show more from France",
        GB: "Show more from England",
        NL: "Show more from Netherlands",
        BE: "Show more from Belgium",
        DE: "Show more from Germany",
        ES: "Show more from Spain",
        IT: "Show more from Italy",
        US: "Show more from USA",
        RS: "Show more from Serbia",
        PT: "Show more from Portugal",
      },
      chooseCountryTitle: "BROWSE BY COUNTRY",
    },
    start: {
      title: "HAVE A GOOD START",
      subtitle: "Select the frame you like most",
      shipping: "Shipping to Netherlands - ",
      shippingButton: "change",
      price: "from",
      continueButton: "Continue with this shirt",
      mobileContinueButton: "Continue",
    },
    configure: {
      sealedAlert: "It is no longer possible to edit this product",
      theSideBar: {
        shipping: "Shipping to {shippingCountry}",
        sideShirtOptionOne: "The Shirt",
        sideShirtOptionTwo: "The Fold",
        sideShirtOptionThree: "The Sleeves",
        back: "Back",
        front: "Front",
        black: "Black",
        aluminium: "Aluminium",
        white: "White",
        custom: "Custom",
        clubLogo: "Club Logo",
        noClubLogo: "No Club Logo",
        plateOptions: {
          brass: "Brass",
          none: "No Plate",
          aluminium: "Aluminium",
        },
        shirtImageStatusIndicator: {
          fallbackImage:
            "The shirt image is a placeholder and does not represent the real appearance of your product",
          shirtImageLoadError:
            "There was an error loading one or more shirt images. Please try refreshing the page or {contactUs}",
        },
        sideColoursOptionOne: "Frame",
        sideColoursOptionTwo: "Passe-Partout / Background",
        sideColourChooseImage: "Choose your image",
        sideGlassTitle: "The Glass",
        sideShipping: "Shipping NL",
        sideShippingChange: "change",
        sideGlassOptionOne: "Glass",
        sideGlassSubTitle: "Choose the type of glass you want us to use",
        sideClubLogoOptionOne: "Club Logo",
        sideClubLogoOptionTwo: "The Logo",
        sideClubLogoSubTitle:
          "Do you want us to place the 6*6cm club logo on top of the frame",
        sideClubLogoColorTitle: "Club logo background",
        sideClubLogoColorHelp:
          "Only visible for logos with transparent background",
        sideMatchPlateTitle: "PLATE",
        sideMatchPlateInfo: "Choose the colour of your frame",
        sideMatchPlateOptionOne: "The Plate",
        sideMatchPlateAdditionalTitle: "ADDITIONAL OPTIONS",
        sidePhoto: "Photo",
        addToCart: "Add to cart",
        toConfirmation: "To confirmation",
        cartSaving: "Saving...",
        cartSaved: "Saved",
        toCheckout: "Order",
        toCart: "Checkout",
        toSummary: "Summary",
        clubLogoSelectTitle: "Select the logo you want on the top of the frame",
        plateLogoSelectTitle: "Select the logo you want on the plate",
      },
      mobileShirtSubtitle: "SHIRT FOLDING",
      mobileColoursSubtitle: "FRAME COLOURS",
      chooseYourImage: "CHOOSE YOUR IMAGE",
      shippingTitle: "SHIPPING",
      shippingInfo:
        "You've done an amazing job! All that now remains is to enter your shipping details and proceed to the checkout",
      photoTitle: "The Photos",
      photoInfo:
        "Do you want us to place one or multiple photos below the frame ?",
      photoOptions: "Photo Options",
      photoPhotos: "The Photos",
      photoUpload: "Upload your own",
      photoUploadWarning: "Please upload photos before continuing.",
      matchPlateWarning: "Please add text to the plate before continuing.",
      informationModal: {
        shirt: {
          title: "Exhibiting your masterpiece",
          content:
            "It's up to you how you choose to display your shirt: from the front or from the back. If there’s a badge or a patch on either of the sleeves that you’re excited to show off, make sure you click the “show sleeves” option.",
        },
        frame: {
          title: "Stunning and sustainable",
          content:
            "Our premium quality frames are carefully crafted to leave the smallest possible carbon footprint. The gorgeous finger-jointed wood comes from Tuscany; the remaining materials are all locally sourced.",
        },
        photos: {
          title: "Photos",
          content:
            "Add photos of your choice to the frame to portray the best moments from the game. Whether it is a celebration or the player kicking a ball, photos will provide for a tailored feel to your frame.",
        },
        plate: {
          title: "A moment immortalised",
          content:
            "Your shirt immortalises a unique moment in sporting history! Provide the context for this moment by adding an important detail about it here, such as the name of the player or the final score of the match. Including the club logo will augment the official appearance of your inscription.",
        },
      },
      sidebar: {
        shirt: {
          fold: "Fold",
          sleeves: "Sleeves",
          sleevesVisible: "Show sleeves",
          noSleeves: "Hide sleeves",
          back: "Back",
          front: "Front",
        },
        logo: {
          logo: "Logo",
          clubLogo: "Club logo",
          noClubLogo: "No club logo",
        },
        frame: {
          frame: "Frame",
          black: "Matte black",
          aluminium: "Aluminium",
        },
        background: {
          background: "Background",
          black: "Black",
          white: "White",
          custom: "Custom",
        },
        plate: {
          plate: "Plate",
          silver: "Silver plate",
          gold: "Brass plate",
          none: "No plate",
          plateLogo: "Plate logo",
          logo: "Logo",
          noLogo: "No logo",
          plateBrandingLogo: "Plate branding",
          brandingLogo: "Branding",
          noBrandingLogo: "No branding",
        },
        photos: {
          photosStep: "Photos",
          none: "No photos",
          noPhotos: "No photos",
          twoPhotos: "Two photos",
          threePhotos: "Three photos",
          left: "Left photo",
          center: "Middle photo",
          right: "Right photo",
          description: "Landscape photos work best",
          uploadPhoto: "Upload photo",
          fileTypeSize: "jpg, jpeg, png, max. 10MB",
        },
        summary: {
          shirt: {
            sleevesVisible: "Show sleeves",
            noSleeves: "Hide sleeves",
            back: "Back of shirt",
            front: "Front of shirt",
          },
          logo: {
            clubLogo: "Club logo",
            empty: "No club logo",
          },
          frame: {
            black: "Matte black frame",
            aluminium: "Aluminium frame",
            custom: "Custom frame",
          },
          background: {
            black: "Black background",
            white: "White background",
            custom: "Custom background",
          },
          plate: {
            silver: "Silver plate",
            gold: "Brass plate",
            none: "No plate",
            plateLogo: "Plate logo",
            logo: "Logo",
            noLogo: "No logo",
            noInscription: "No inscription",
            brandingLogo: "Branding",
            noBrandingLogo: "No branding",
          },
          photos: {
            none: "No photos",
            twoPhotos: "Two photos",
            threePhotos: "Three photos",
          },
          basePrice: "Base price",
          frameHeader: "Frame",
          orderNow: "Order now",
          orderError:
            "We encountered an issue while creating your order. Please try again or reach out to our customer support team for assistance.",
          summary: "Summary",
          shipping: "Shipping to {shippingCountry}",
          subtotal: "Subtotal",
          photosRemovedMessage: "You did not upload all photos",
          tax: "Tax {taxPercentage}%",
          unknownShipping: "Shipping costs are calculated at checkout",
          discountApplied: "{PLACEHOLDER_percentage}% off applied",
        },
        continue: "Continue",
        disabled: "disabled",
        select: "Select",
        loading: "Loading...",
        option: "option",
        dutiesAndTaxes: "Excl. duties and/or taxes",
        vatApplicable: "All prices are including VAT",
        customsPrice: "Customs and duties may apply",
        included: "Included",
        priceFrom: "Price from",
      },
    },
    mobileShirtSubtitle: "SHIRT FOLDING",
    mobileColoursSubtitle: "FRAME COLOURS",
    chooseYourImage: "CHOOSE YOUR IMAGE",
    shippingTitle: "SHIPPING",
    shippingInfo:
      "You've done an amazing job! All that now remains is to enter your shipping details and proceed to the checkout",
    photoTitle: "The Photos",
    photoInfo:
      "Do you want us to place one or multiple photos below the frame ?",
    photos: "Photos",
    photoPhotos: "The Photos",
    photoUpload: "Upload your own",
    photoUploadWarning: "Please upload photos before continuing.",
    matchPlateWarning: "Please add text to the plate before continuing.",
    customization: {
      continueButtonText: "Continue to checkout",
      confirm: "Confirm",
      confirmed: "Confirmed",
      quantity: "Quantity",
      happyCheck: " Yes, I'm happy with my frame",
      emailSaveTitle: "SAVE YOUR CONFIGURATION",
      emailSaveSubtitle:
        "Leave your email and we will send you a link to get back to this configuration",
      pluralization: "Customisations",
      total: "Total",
      subtotal: "Subtotal",
      shipping: "Shipping to {country}",
      shippingCosts: "Shipping costs",
      shippingCalculation: "calculated in the next step",
      totalPrice: "Total price",
      vatMessage: "VAT included where applicable",
      customsPrice: "Customs and duties may apply",
      vatPrice: "Incl. {price} VAT ({percentage}%)",
      vatAndDuties:
        "Please note that our frames are produced in and shipped from either the UK or the Netherlands. Therefore customs duties and VAT may apply depending on your shipping address.",
      shirtTitle: "Starting",
      edit: "edit",
      editConfiguration: "edit configuration",
      confirmation: {
        confirm: "Confirm",
        cancel: "Cancel",
      },
    },
    MatchPlateInscription: {
      title: "Plate Inscription",
      info: "Add engraving",
      placeholder: "Add inscription text here",
    },
    notFound: {
      title: "404",
      subtitle: "Page not found",
      link: "Go back to home",
    },
    b2bCustomerPage: {
      acceptButton: "Accept",
      rejectButton: "Reject",
      acceptInfo: "I am sure I want to accept this configuration.",
      rejectInfo:
        "No, I do not want to accept this configuration. The reason is:",
      confirmButton: "Confirm",
      returnButton: "Return",
      customizationButton: "Customizations",
      alert: {
        reasonAlert: "Please fill in the reject reason.",
        acceptSuccess: "Congratulations! You have accepted the configuration! ",
        rejectSuccess: "You have submited the reject request and reason.",
      },
      acceptBar: "You have accepted this configuration!",
      rejectBar: "You have rejected this configuration.",
    },
  },
  modal: {
    button: "Continue customizing",
    error: {
      title: "Something went wrong",
      message:
        "Please try again. If the problem persists, please {customerServiceLink}.",
      contactCustomerService: "contact customer service",
    },
    matchplate: {
      notion: "Maximum of 4 lines, 31 characters per line",
      title: "INSCRIPTION PREVIEW",
    },
    photoUpload: {
      title: "DRAG & REPOSITION PHOTO",
    },
  },
  colorPicker: {
    customBack: "Back",
    customTitle: "CUSTOM COLOR",
    backgroundPickTitle: "BACKGROUND",
    clubPickTitle: "CLUB",
    modelButton: "Continue customizing",
    hue: "Hue:",
    saturation: "Saturation:",
    lightness: "Lightness:",
  },
  imageUpload: {
    position: "Position",
    zoom: "Zoom",
    positionTitle: "Drag to position the image in the right spot",
    zoomTitle: "Drag to the left or right to zoom",
    uploadHelp: "Please click or drag-and-drop to upload image",
    frameOverlapNote:
      "The edges of your photo will be covered by the surrounding frame.",
    imageBackgroundNote:
      "If the photo has a transparent background, we will place an appropriate colour behind it.",
    imageSizeNote: "The maximum size for image is 10MB.",
    origin: "Recover Original",
    delete: "Delete",
    cancel: "Cancel",
    save: "Upload",
    reposition: "Reposition",
    imageLowResolution:
      "This photo's resolution is low for printing and may look pixelated. Try zooming out or choosing a higher-resolution photo.",
    imageBlurry:
      "Your photo is blurry and may not look sharp when printed. We recommend you use a different photo.",
    imageLowResolutionAndBlurry:
      "This photo is low resolution and looks blurry, so it may not print well. We recommend you use a different photo.",
    imageFileSizeTooLarge:
      "This image is too large. Images must be less than 10MB.",
  },
  alert: {
    matchPlate: "Since you selected three photos, cannot add a plate anymore!",
    pickup: "Museum glass can only be picked up!",
    shipping: "Regular glass can only be shipped!",
  },
  checkoutOverlay: {
    redirect: "You will be redirected to the checkout page shortly",
  },
  b2b: {
    configurationConfirmed:
      "Configuration confirmed, this cart is now pending customer confirmation",
  },
  preset: {
    alert: {
      confirmSuccess: "Successfully confirmed the preset configuration!",
    },
  },
  transitionPage: {
    message: "just a second, we are crafting your frame...",
  },
};
